import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ 
  type = 'no-data',
  onAction,
  hasFilters = false,
  onClearFilters 
}) => {
  const getEmptyStateContent = () => {
    switch (type) {
      case 'no-results':
        return {
          icon: 'Search',
          title: 'لا توجد نتائج',
          description: 'لم يتم العثور على اتحادات فرعية تطابق معايير البحث المحددة',
          actionText: 'مسح الفلاتر',
          actionIcon: 'X',
          onActionClick: onClearFilters
        };
      case 'error':
        return {
          icon: 'AlertCircle',
          title: 'خطأ في تحميل البيانات',
          description: 'حدث خطأ أثناء تحميل بيانات الاتحادات الفرعية. يرجى المحاولة مرة أخرى',
          actionText: 'إعادة المحاولة',
          actionIcon: 'RefreshCw',
          onActionClick: onAction
        };
      default:
        return {
          icon: 'Building2',
          title: 'لا توجد اتحادات فرعية',
          description: 'لم يتم إنشاء أي اتحادات فرعية بعد. ابدأ بإضافة أول اتحاد فرعي',
          actionText: 'إضافة اتحاد فرعي',
          actionIcon: 'Plus',
          onActionClick: onAction
        };
    }
  };

  const content = getEmptyStateContent();

  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="w-24 h-24 bg-muted rounded-full flex items-center justify-center mb-6">
        <Icon 
          name={content?.icon} 
          size={48} 
          className="text-muted-foreground" 
        />
      </div>
      <div className="text-center max-w-md">
        <h3 className="text-xl font-semibold text-foreground mb-2 font-arabic">
          {content?.title}
        </h3>
        
        <p className="text-muted-foreground mb-6 leading-relaxed">
          {content?.description}
        </p>

        {content?.onActionClick && (
          <Button
            variant="default"
            onClick={content?.onActionClick}
            iconName={content?.actionIcon}
            iconPosition="left"
            iconSize={20}
            className="px-6"
          >
            {content?.actionText}
          </Button>
        )}

        {type === 'no-results' && hasFilters && (
          <div className="mt-4 pt-4 border-t border-border">
            <p className="text-sm text-muted-foreground mb-3">
              نصائح للبحث:
            </p>
            <ul className="text-sm text-muted-foreground space-y-1 text-right">
              <li>• تأكد من صحة الكلمات المفتاحية</li>
              <li>• جرب استخدام كلمات أقل تحديداً</li>
              <li>• تحقق من فلاتر المدينة والحالة</li>
              <li>• امسح جميع الفلاتر وابدأ من جديد</li>
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmptyState;